import ExecuteSearchResponseMessage from 'owa-service/lib/contract/ExecuteSearchResponseMessage';
import ItemTypesFilter from 'owa-service/lib/contract/ItemTypesFilter';
import { addSearchResultsItemId } from '../actions/privateActions';
import { getSearchResultSet } from 'mini-3s-service/lib/utils/getSearchResultSet';
import { MailSearchResults } from '../store/schema/MailSearchResults';
import { mapSearchResultConversationToConversationType } from './mapSearchResultsConversationToConversationType';
import { mapSearchResultMessageToMessageType } from './mapSearchResultsMessageToMessageType';
import { SubstrateEntityType } from 'mini-3s-service/lib/schema/SubstrateEntityType';
import {
    SubstrateSearchResponse,
    SearchResultMessage,
    SearchResultConversation,
} from 'mini-3s-service/lib/schema/SubstrateSearchResponse';

/**
 * Processes the response from Query API to return MailSearchResults
 * @param response
 * @param searchRequest
 * @param entityType
 */
export function getMailSearchResultsFromSubstrateSearchResponse(
    response: SubstrateSearchResponse,
    requestTimeZone: string,
    entityType: SubstrateEntityType
): MailSearchResults {
    const traceId = response?.Instrumentation?.TraceId;
    const resultSet = getSearchResultSet(response);
    const results = resultSet?.Results ?? [];

    /** Map substrate response type to executeSearch response type so that they are compatible with the MailList and other operations */
    return {
        hasError: false,
        areMoreResultsAvailable: !!resultSet?.MoreResultsAvailable,
        rows: results.map(result => {
            const { Source, ReferenceId } = result;
            const isConversation = entityType === SubstrateEntityType.Conversation;
            const itemOrConversationId = isConversation
                ? Source.ConversationId.Id
                : Source.ItemId.Id;
            addSearchResultsItemId(itemOrConversationId, ReferenceId, traceId);
            return isConversation
                ? mapSearchResultConversationToConversationType(
                      Source as SearchResultConversation,
                      requestTimeZone
                  )
                : mapSearchResultMessageToMessageType(
                      Source as SearchResultMessage,
                      requestTimeZone
                  );
        }),
    };
}

/**
 * Processes the response from ExecuteSearch to return MailSearchResults
 * @param response
 * @param entityType
 */
export const getMailSearchResultsFromExecuteSearchResponse = (
    response: ExecuteSearchResponseMessage,
    entityType: ItemTypesFilter
): MailSearchResults => {
    const searchResults = response.SearchResults;
    const resultEntities =
        searchResults && entityType === 'MailConversations'
            ? searchResults.Conversations
            : searchResults.Items;

    return {
        hasError: false,
        areMoreResultsAvailable: searchResults?.MoreResultsAvailable,
        rows: resultEntities,
    };
};
